import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "app-rating"

  connect() {
    super.connect()
    this.send("request", {}, () => {})
  }
}
